import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { combineReducers } from 'redux';

import BinaryImageType from './BinaryImageType';
import SecurazeTool from './SecurazeTool';
import BinaryImages from './BinaryImages';
import BinaryImagesCreate from './BinaryImages/BinaryImageCreate';
import BinaryImagesEdit from './BinaryImages/BinaryImageEdit';

import binaryImagesReducer from './BinaryImages/store/binaryImagesReducer';
import binaryImageTypeReducer from './BinaryImageType/store/binaryImageTypeReducer';
import securazeToolsReducer from './SecurazeTool/store/securazeToolsReducer';

export const routes = (basePath) => (
    < Switch >
        {< Route path={basePath + '/binaryImageType'} exact component={BinaryImageType} />}
        {< Route path={basePath + '/securazeTool'} exact component={SecurazeTool} />}
        {< Route path={basePath + '/binary-images'} exact component={BinaryImages} />}
        {< Route path={basePath + '/binary-images/create'} exact component={BinaryImagesCreate} />}
        {< Route path={basePath + '/binary-images/edit'} exact component={BinaryImagesEdit} />}

    </Switch >
);

export const subComponents = (translations) => [
    { name: translations["binary_images"] || "Binary Images", path: '/binary-images', permissions: ['binary_image_list'] },
    { name: translations["securaze_tool"] || "Securaze tool", path: '/securazeTool', permissions: ['securaze_tool_list'] },
    { name: translations["binary_image_type"] || "Binary image type", path: '/binaryImageType', permissions: ['binary_image_type_list'] },
];

export const reducers = combineReducers({
    binaryImageType: binaryImageTypeReducer,
    securazeTools: securazeToolsReducer,
    binaryImages: binaryImagesReducer
});